import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "value--null"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["title"];
const _hoisted_4 = { key: 4 };
const _hoisted_5 = { key: 5 };
const _hoisted_6 = {
    key: 6,
    class: "badge"
};
import { computed } from 'vue';
import { dataTypeFilter, dateTimeMillisTzFilter } from "../util/CommonUiFilters";
import Icon from "./Icon.vue";
import FileLink from "./FileLink.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DataTableCell',
    props: {
        value: {},
        type: {},
        showNulls: { type: Boolean },
        translationPrefix: {},
        item: {},
        column: {}
    },
    setup(__props) {
        const props = __props;
        const badgeIcon = computed(() => {
            if (props.type == 'badge' && props.column.name === 'status') {
                switch (props.item.status) {
                    case 'neutral':
                        // common status values
                        if ("active" === props.value || "enabled" === props.value) {
                            return 'circle-check';
                        }
                        if ("inactive" === props.value || "disabled" === props.value) {
                            return 'ban';
                        }
                        return undefined;
                    case 'draft':
                        return 'pen-circle';
                    case 'invalid':
                        return 'circle-xmark';
                    case 'important':
                        return 'circle-exclamation';
                    case 'disabled':
                        return 'ban';
                    case 'success':
                        return 'circle-check';
                }
            }
            return undefined;
        });
        return (_ctx, _cache) => {
            return (__props.value === null || __props.value === undefined)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                    (__props.showNulls)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("\n            null\n        ")
                        ], 64))
                        : _createCommentVNode("", true)
                ]))
                : (__props.type === 'image')
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: __props.value
                    }, null, 8, _hoisted_2))
                    : (__props.type === 'bool')
                        ? (_openBlock(), _createBlock(Icon, {
                            key: 2,
                            name: __props.value ? 'check-square' : 'square'
                        }, null, 8, ["name"]))
                        : (__props.type === 'datetime')
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 3,
                                title: _unref(dateTimeMillisTzFilter)(__props.value)
                            }, _toDisplayString(_unref(dataTypeFilter)(__props.value, __props.type)), 9, _hoisted_3))
                            : (__props.type === 'secret')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "\n        ******\n    "))
                                : (__props.type === 'file' && __props.value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                        _createVNode(FileLink, { uri: __props.value }, null, 8, ["uri"])
                                    ]))
                                    : (__props.type === 'badge')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                                            (badgeIcon.value)
                                                ? (_openBlock(), _createBlock(Icon, {
                                                    key: 0,
                                                    name: badgeIcon.value
                                                }, null, 8, ["name"]))
                                                : _createCommentVNode("", true),
                                            _createTextVNode(" " + _toDisplayString(__props.translationPrefix && _ctx.$te(__props.translationPrefix + __props.value) ? _ctx.$t(__props.translationPrefix + __props.value) : __props.value), 1)
                                        ]))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                            _createTextVNode(_toDisplayString(_unref(dataTypeFilter)(__props.value, __props.type)), 1)
                                        ], 64));
        };
    }
});
